import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const Publicidade = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const condicional = useSelector((state) => state.addForm.modulos)
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="PUBLICIDADE" />
                    <div style={{ textAlign: "left" }}>
                        <HeaderVerde texto="Meio Físico" />
                        <Select label="Divulgação de Imagens do Paciente com Autorização Formal" nome="divulgacaoimg" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="10vw" widthMobile="80vw" marginR="2vw"
                            array={["Divulgação com autorização", "Divulgação sem autorização", "Não há divulgação"]} />
                        <Select label="Divulgação de Carta de Agradecimento do Paciente com Autorização Formal" nome="divulgacaocarta" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="10vw" widthMobile="80vw" marginR="2vw"
                            array={["Divulgação com autorização", "Divulgação sem autorização", "Não há divulgação"]} />
                        <Select label="Divulgação de Honorários" nome="divulgacaohono" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="10vw" widthMobile="80vw" marginR="2vw"
                            array={["Sim", "Não"]} />
                        <Select label="Divulgação Atendimento Gratuito/ Concorrência Desleal" nome="divulgacaoated" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="10vw" widthMobile="80vw" marginR="2vw"
                            array={["Sim", "Não"]} />
                        <Select label="Divulgação de Promessa Infalível" nome="divulgacaopromessa" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="10vw" widthMobile="80vw" marginR="2vw"
                            array={["Sim", "Não"]} />
                    </div>
                    <HeaderVerde texto="LEGALIDADE" />
                    <div style={{ textAlign: "left" }}>
                        <Select label="CONFORMIDADE COM A RESOLUÇÃO COFFITO Nº 424/2013 ou 425/2013" nome="resolucao424425" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="10vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />

                    </div>
                    <Observacoes widthWeb="83vw" widthMobile="80vw" modulo={modulo} index={n} nome="observacoes" />
                </Caixa>
            )
        }
        return partes
    }
}
export default Publicidade